import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { ShieldAlert, X } from "lucide-react";

// Silent security check — renders nothing unless suspicious signals are present.
export default function SecurityBanner() {
  const [status, setStatus] = useState(null);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("cal_sec_dismissed") === "1");

  useEffect(() => {
    if (dismissed) return;
    api.get("/auth/security-status").then((r) => setStatus(r.data)).catch(() => { /* silent */ });
  }, [dismissed]);

  if (dismissed || !status || !status.suspicious) return null;

  const dismiss = () => {
    sessionStorage.setItem("cal_sec_dismissed", "1");
    setDismissed(true);
  };

  return (
    <div
      className="mb-6 cal-card cal-shadow p-5 flex items-start gap-4"
      style={{ background: "#FFF6E0", borderColor: "#111" }}
      data-testid="security-banner"
    >
      <ShieldAlert className="flex-shrink-0 mt-1" size={22} style={{ color: "#B00020" }} />
      <div className="flex-1">
        <div className="font-mono-cal text-[10px] uppercase tracking-widest text-[#B00020] mb-1">[ SECURITY · LAST 24H ]</div>
        <h3 className="font-display font-bold text-lg leading-tight">Unusual activity detected on your account</h3>
        <p className="text-sm text-[#444] mt-2 leading-relaxed">
          We've recorded <strong>{status.forgot_attempts_24h}</strong> password-reset attempt{status.forgot_attempts_24h === 1 ? "" : "s"}
          {status.ips_other_than_current.length > 0 && (
            <> from {status.ips_other_than_current.length} IP{status.ips_other_than_current.length === 1 ? "" : "s"} you haven't used this session</>
          )}.
          {status.reset_completions_24h > 0 && <> <strong>{status.reset_completions_24h}</strong> reset{status.reset_completions_24h === 1 ? " was" : "s were"} actually completed.</>}
        </p>
        <div className="mt-3 text-xs font-mono-cal text-[#666]">
          <div>Your current IP: {status.current_ip}</div>
          {status.ips_other_than_current.length > 0 && (
            <div>Other IPs: {status.ips_other_than_current.slice(0, 5).join(", ")}</div>
          )}
        </div>
        <div className="mt-4 flex flex-wrap gap-3">
          <Link to="/forgot-password" className="cal-btn" data-testid="sec-reset-btn">Reset password now →</Link>
          <button onClick={dismiss} className="cal-btn cal-btn-ghost" data-testid="sec-dismiss-btn">Dismiss for this session</button>
        </div>
      </div>
      <button onClick={dismiss} className="p-1 hover:bg-[#111]/5" aria-label="Close" data-testid="sec-close-btn">
        <X size={16} />
      </button>
    </div>
  );
}
